import { useEffect, useState } from "react";
import CustomButton from "../../components/customButton";
import { FaArrowLeft, FaCreditCard } from "react-icons/fa";
import useDeliveryStore from "../../store/order/passerCommande";
// import usePaymentStore from "../../store/order/paiement";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import useCartDetail from "../../store/cart/getcartDetails";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  // DialogFooter,
  // DialogHeader,
  // DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";

// import { Button } from "../../components/ui/button";
// import { Input } from "../../components/ui/input";
import axios from "axios";
// import useStoreQuantite from "../livraison/store";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/Breadcrumb";
import { formatNombre, scrollToTop } from "../../lib/utils";
import { paiementCommande } from "../../lib/apis";

// Définir le type PaymentInput
// eslint-disable-next-line
type PaymentInput =
  | {
    order_id: number;
    payment_method: "OM" | "MOMO";
    phone_number: string;
  }
  | {
    order_id: number;
    payment_method: "Card";
    card_number: string;
    cvc: string;
    expiration_date: string;
  };

const Paiement = () => {
  const [open, setOpen] = useState(false);
  const { orderResponse } = useDeliveryStore((state) => state);
  const location = useLocation();
  const newOrder = location.state;
  const { t, i18n } = useTranslation()
  // const { cartDetails, fetchAllCat } = useCartDetail();
  const orderId = useParams().id; // Retrieve order_id from route parameter


  useEffect(() => {
    scrollToTop()
  }, [])

  const navigate = useNavigate();

  const [loading1, setLoading1] = useState(false);

  const token = localStorage.getItem("token");

  const [selectedPayment, setSelectedPayment] = useState<
    "OM" | "MOMO" | "Card"
  >("OM");
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  const [achat, setAchat] = useState<any>();

  const [cardDetails, setCardDetails] = useState({
    cardNumber: "",
    cvc: "",
    expirationDate: "",
  });

  // console.log("orderResponse", orderResponse?.data.order_id);

  const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPayment(event.target.value as "OM" | "MOMO" | "Card");
  };

  const handleCreditCardClick = () => {
    setSelectedPayment("Card");
  };

  const request = async () => {
    if (!orderId) {
      console.error("Order ID is missing. Unable to proceed with payment.");
      alert("Order ID is missing. Please try again.");
      return;
    }

    setLoading1(true);

    try {
      const { data } = await axios.post(`${paiementCommande}`,
        {
          order_id: orderId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )


      window.open(data.paymentUrl)
      navigate("/commandes")

    } catch (error: any) {
      console.error("Payment error:", error);
      toast.error(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE, {
        position: "bottom-right",
      });
    } finally {
      setLoading1(false);
    }
  };

  // const { quantitee } = useStoreQuantite();
  console.log("detail du panier", cardDetails)

  return (
    <div className="h-full pt-2 bg-softGrey">
      <div className="flex flex-row  items-center py-5 justify-start w-full ml-10">

        <Breadcrumb />
      </div>
      <div className="w-full flex justify-center items-center py-5 bg-white">
        <h1 className="text-[20px]">{t("passer_commande")} ({newOrder.products.length} {t("produit")})</h1>
      </div>
      <div className=" ">
        {/* <div className="col-span-3">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px] ">
            <div className="flex flex-col items-start justify-start">
              <div className="text-2xl mt-2">{t("service_de_paiement")}</div>
              <div className="text-1xl my-4">{t("mode_paiement")}</div>
              <div className="flex items-center justify-between mb-4 gap-4">
               
                <div className="flex flex-row">
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input
                      type="radio"
                      name="payment"
                      value="OM"
                      checked={selectedPayment === "OM"}
                      onChange={handlePaymentChange}
                    />
                    <span className="text-sm text-gray-400">OM</span>
                  </label>
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input
                      type="radio"
                      name="payment"
                      value="MOMO"
                      checked={selectedPayment === "MOMO"}
                      onChange={handlePaymentChange}
                    />
                    <span className="text-sm text-gray-400">MOMO</span>
                  </label>
                </div>
              </div>
              
              {selectedPayment !== "Card" && (
                <div className="mb-4 w-[100%]">
                  <input
                    type="text"
                    placeholder={t("entrer_numero_telephone")}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="w-[100%] p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
              )}
            </div>
          </div>
        </div> */}
        <div className="col-span-2">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px] ">
            <div className="flex flex-col h-full justify-between">
              <div className="my-2 text-2xl">{t("mes_produits")}</div>
              <div className="text-center">
                <div className="border-t border-gray-300"></div>
                <div className="flex justify-between my-2 text-gray-500">
                  <div className="w-full ">

                    {newOrder.products.map((item: any, index: any) => (
                      <div key={index} className="flex w-100  justify-between">
                        <span>
                          {`${item.quantity}
                          ${item.product_name}`}
                        </span>
                        <div>{formatNombre(item.subtotal)} FCFA</div>
                      </div>

                    ))}
                  </div>

                </div>
                <div className="border-t border-gray-300"></div>
              </div>
              <div className="flex justify-between ">
                <div className="font-bold">Total</div>
                <div className="font-bold">
                  {orderResponse?.data.total_amount}
                </div>
              </div>
              <div className="flex items-center">
                <div className="text-xs">{t("prix_total")} ({newOrder.products.length} {t("produit")}):</div>
                <div className="font-bold text-1xl ml-1">
                  {formatNombre(newOrder.total_amount)} FCFA
                </div>
              </div>
              <div className="flex justify-center w-full">
                <CustomButton
                  onClick={request}
                  rounded
                  className="bg-primary text-white px-8 py-3 text-[11px] max-w-[300px] w-full"
                  disabled={loading1}
                >
                  <span>
                    {loading1
                      ? t("chargment")
                      : t("payer_commande")}
                  </span>
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={open}>
        <DialogTrigger asChild></DialogTrigger>
        <DialogContent className="sm:max-w-[425px] p4">
          <DialogDescription className="flex flex-col gap-3 p-4 items-center">
            <h4 className="text-[15px] font-normal">
              {t("paiement_reussit")} !!!
            </h4>
            {/*  <span className="text-grey text-[11px] font-normal">
              {" "}
              lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. lorem{" "}
            </span> */}
            <CustomButton
              rounded
              className="px-4 py-2 bg-primary w-full"
              onClick={() => {
                navigate(`/recherche_trans/${orderId}`);
              }}
            >
              <span className="text-white text-[11px]">
                {t("bessoin_transporteur")}
              </span>
            </CustomButton>
            <CustomButton
              rounded
              className="px-4 py-2 bg-third w-full"
              onClick={() => {
                navigate("/commandes");
              }}
            >
              <span className="text-[11px]">{t("voir_commande")}</span>
            </CustomButton>
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

export default Paiement;
